import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { computed, watch } from "vue";
import { SearchSelectOption } from "@/types";
import { searchModeOptions } from "@/util";
import { permissionStore, searchStore } from "@/hooks";
import { ListItem, Separator } from "@/components/common";


/**
 * Displays an input for selecting the type of search to perform.
 */
const __default__ = {
  name: "SearchModeInput",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const modeOptions = computed(() => {
  const allOptions = searchModeOptions();
  const currentOptions = searchModeOptions().slice(0, 2);

  if (permissionStore.isAllowed("project.edit_data")) {
    currentOptions.push(allOptions[2]);
  }
  if (permissionStore.isAllowed("project.generate")) {
    currentOptions.push(allOptions[3]);
  }

  return currentOptions;
});

/**
 * Clear the search data when the mode changes.
 */
watch(
  () => searchStore.mode,
  () => searchStore.clearSearch()
);

return (_ctx: any,_cache: any) => {
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, {
    modelValue: _unref(searchStore).mode,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchStore).mode) = $event)),
    outlined: "",
    label: "Search Mode",
    options: modeOptions.value,
    "option-label": "name",
    "option-value": "id",
    class: "nav-input nav-search-mode nav-multi-input-left",
    "data-cy": "input-nav-search-mode"
  }, {
    option: _withCtx(({ opt, itemProps }: { opt: SearchSelectOption }) => [
      (opt.id === 'search')
        ? (_openBlock(), _createBlock(_unref(Separator), { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_unref(ListItem), _mergeProps({
        clickable: "",
        title: opt.name,
        subtitle: opt.description
      }, itemProps), null, 16, ["title", "subtitle"])
    ]),
    _: 1
  }, 8, ["modelValue", "options"]))
}
}

})